import { createRoot } from "react-dom/client";
import { ThemeProvider } from "next-themes";
import App from "./App.tsx";
import "./index.css";
import "react-day-picker/style.css";
import { AppErrorBoundary } from "@/components/app/AppErrorBoundary";
import { installGlobalErrorMonitoring } from "@/lib/monitoring";

installGlobalErrorMonitoring();

createRoot(document.getElementById("root")!).render(
  <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
    <AppErrorBoundary><App /></AppErrorBoundary>
  </ThemeProvider>
);
